var map = {
	"./banner-mobile.jpg": 32,
	"./banner.jpg": 160,
	"./casabela-1.png": 161,
	"./casabela-2.png": 162,
	"./casabela-3.png": 163,
	"./casabela-4.png": 164,
	"./casabela-5.png": 165,
	"./print1.png": 166,
	"./print2.png": 167,
	"./ser-arvore-1.jpg": 168,
	"./ser-arvore-2.jpg": 169,
	"./ser-arvore-3.jpg": 170,
	"./ser-arvore-4.jpg": 171
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 34;


//////////////////
// WEBPACK FOOTER
// ./src/assets ^\.\/.*$
// module id = 34
// module chunks = 1